import React from 'react'
import Button from 'gu-ui-kit/Button'
import Icon from 'gu-ui-kit/Icon'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

export const BackButton = ({ url }) => {
  const pathGen = useGeneratePathI18n()

  return (
    <Button
      grey
      noLabel
      component={url === pathGen(ROUTES.MAIN) ? 'a' : Link}
      size={'s'}
      startIcon={<Icon name={'back'} />}
      variant={'ghost'}
      {...{ [url === pathGen(ROUTES.MAIN) ? 'href' : 'to']: url }}
    />
  )
}

BackButton.propTypes = {
  url: PropTypes.string,
}
